<template>
  <div :class="{'marque-header':marque}" class="flex f-between f-center blinki-header fixed-top flex-md-nowrap">
    <div class="mt-3 flex f-center enviemoment-container">
      <div class="flex f-between full-width">
        <div
          class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 enviemoment-title"
        >
          <h1 class="title-sandwich flex pointer" @click="fullScreen()">
            <span id="marque-popover" class="icon-sandiwch-bar title-bar mr-3 not-enable"></span>
            <b-popover  v-if="marque" target="marque-popover" triggers="focus hover  " placement="bottom">
              <b-list-group class="dropdown-marque">
                <b-list-group-item  button  class="d-flex justify-content-between align-items-center pointer">
                  <nuxt-link to="/" class="text-capitalize text-decoration-none" >
                    <p class="m-0 mr-2 big-font">Accueil</p>
                  </nuxt-link>
                </b-list-group-item>
                <b-list-group-item  button  class="d-flex justify-content-between align-items-center pointer">
                  <nuxt-link to="/livraisons" class="text-capitalize text-decoration-none">
                    <p class="m-0 mr-2 big-font">Gestion des livraisons</p>
                  </nuxt-link>
                </b-list-group-item>
                <b-list-group-item  button  class="d-flex justify-content-between align-items-center pointer">
                  <nuxt-link to="/commandes" class="text-capitalize text-decoration-none">
                    <p class="m-0 mr-2 big-font">Gestion des commandes</p>
                  </nuxt-link>
                </b-list-group-item>
                <b-list-group-item  button  class="d-flex justify-content-between align-items-center pointer">
                  <nuxt-link to="/retours" class="text-capitalize text-decoration-none">
                    <p class="m-0 mr-2 big-font">Gestion des retours</p>
                  </nuxt-link>
                </b-list-group-item>
                <b-list-group-item  button  class="d-flex justify-content-between align-items-center pointer">
                  <nuxt-link to="/messagerie" class="text-capitalize text-decoration-none">
                    <p class="m-0 mr-2 big-font">Messagerie</p>
                  </nuxt-link>
                </b-list-group-item>
              </b-list-group>
            </b-popover>
            <span class="title">{{ title }}</span>
          </h1>
        </div>
      </div>
    </div>
    <div class="flex">
      <b-dropdown style="max-height: 20px">
        <template v-slot:button-content>
          <div class="flex f-center" style="max-height: 10px">
            <div class="pr-2">
              <div class="person-name">{{ user.fullname | if_null }}</div>
              <div class="perspne-role">{{ user.role | if_null }}</div>
            </div>
            <div class="person pl-2" style="max-height: 30px">
              <span
                class="icon-round-account"
                style="max-height: 30px; font-size: 30px"
              ></span>
            </div>
          </div>
        </template>
        <b-dropdown-item>
          <a   v-b-modal.profil-update @click="getProfilInfos()" class="nav-link">Profil</a>
          <profil-update />
        </b-dropdown-item>
        <b-dropdown-item v-if="marque">
          <a  v-b-modal.marque-update @click="setMarque" class="nav-link">Ma Marque</a>
          <updateMarque :marque="currentMarque" />
        </b-dropdown-item>
        <b-dropdown-item>
          <a @click="logout()" class="nav-link" href="#">Déconnexion</a>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
import { MENU as menu } from "~/api/menu.js";
import { ROLES as roles } from "~/api/variables.js";
import profilDetails from "~/components/popups/profil/details";
import profilUpdate from "~/components/popups/profil/update";
import updateMarque from '~/components/popups/marques/add'
import {getLoggedUser} from "@/helpers";

export default {
  components: {
    profilDetails,
    profilUpdate,
    updateMarque
  },
  data() {
    return {
      roles: roles,
      full: false,
      currentMarque: {}
    };
  },
  methods: {
    setMarque(){
      let user = getLoggedUser();
      if (this.marque)
        this.currentMarque = user.marque[0];
      else
        this.currentMarque = {};
    },
    logout() {
      this.$store.dispatch("auth/logout", { redirect: true });
    },
    getProfilInfos() {
      this.$store.dispatch("auth/me");
    },
    fullScreen() {
      this.full = !this.full;
      this.$store.dispatch("theme/toggleMenu", this.full);
    },
  },
  computed: {
    title() {
      const found = menu.find((elem) => (elem.path === this.$route.path || elem.path + '/' === this.$route.path));
      return found ? found.title : null;
    },
    marque(){
      return this.user.role === 'Marketeur';
    },
    user() {
      const user = this.$store.state.auth.user;
      return user
        ? {
            fullname:
              user.prenom.charAt(0).toUpperCase() +
              user.prenom.slice(1) +
              " " +
              user.nom.toUpperCase(),
            role: this.roles[user.role] ? this.roles[user.role].label : "N/A",
          }
        : {};
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~/assets/css/theme.scss";

.blinki-header {
  -webkit-box-shadow: 0px 15px 5px -11px rgba(221, 221, 221, 1);
  -moz-box-shadow: 0px 15px 5px -11px rgba(221, 221, 221, 1);
  box-shadow: 0px 15px 5px -11px rgba(221, 221, 221, 1);
  height: 56px;
  padding-left: 375px;
  background-color: $white-color;
}

.person [class^="icon-"] {
  font-size: 37px;
  color: $main-color;
}

.person {
  margin: 0 40px 0 0px;
  height: 58px;
  line-height: 1;
  display: flex;
  align-items: baseline;
  max-height: 30px;
  padding-left: 23px !important;
  margin-left: 0 !important;
}

/deep/ a {
  color: $secondary-color !important;
  font-size: 26px;
}

.title {
  color: $main-color;
  font-size: 27px;
}

.title-bar {
  color: $secondary-color;
  font-size: 33px;
}

.person-name {
  font-size: 15px;
  font-weight: bold;
  color: $primary-text-color;
}

.perspne-role {
  font-size: 12px;
  text-align: right;
  color: $second-text-color;
}

.dropdown-menu {
  min-width: auto;
  padding: 3px;
}

a.dropdown-item {
  padding: 3px;
}

a.nav-link {
  font-size: 13px;
  padding: 3px;
}

/deep/ .nav-pills .nav-link.active,
/deep/ .nav-pills .show > .nav-link {
  background-color: transparent;
  padding: 0;
}

/deep/ .nav-link {
  padding: 0 !important;
  padding-left: 3px !important;
}

/deep/ .btn-secondary,
/deep/ .btn-secondary:hover,
/deep/ .show > .btn-secondary.dropdown-toggle,
/deep/ .btn-secondary:not(:disabled):not(.disabled):active,
/deep/ .btn-secondary:focus,
/deep/ .btn-secondary:not(:disabled):not(.disabled):active:focus,
/deep/ .btn-secondary:not(:disabled):not(.disabled).active:focus,
/deep/ .show > .btn-secondary.dropdown-toggle:focus,
/deep/ .btn-secondary.dropdown-toggle:focus {
  background-color: transparent;
  border-color: transparent;
  box-shadow: none !important;
  outline: none !important;
}

/deep/ .dropdown-toggle::after {
  color: $secondary-color;
  position: absolute;
  bottom: 1px;
  right: 86px;
  font-size: 30px;
}
/deep/ .marque .dropdown-toggle::after{
  color: $secondary-color;
  position: absolute;
  //display: none;
  right: 0;
  font-size: 30px;
}

.dropdown {
  height: 74px !important;
}

@media (max-width: 1000px) {
  .not-enable {
    display: none;
  }
}

/deep/ .dropdown-menu.show {
  top: 16px !important;
  border-top: none !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  left: 3px !important;
  width: 240px !important;
}
.marque-header{
  padding-left: 20px !important;
}
/deep/ .popover-body{
  padding: 0;
}
/deep/ .dropdown-marque a p{
  font-size: 18px;
}
</style>
